import { put, takeEvery, call } from "redux-saga/effects";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { push } from "connected-react-router";
import {
  FETCH_TRIPS_INIT,
  FETCH_TRIPS_SUCCESS,
  FETCH_TRIPS_FAIL,
  FETCH_TRIPDETAILSBYID_INIT,
  FETCH_TRIPDETAILSBYID_SUCCESS,
  FETCH_TRIPDETAILSBYID_FAIL,
  FETCH_COMPLETEDLOADDATA_INIT,
  FETCH_COMPLETEDLOADDATA_SUCCESS,
  FETCH_COMPLETEDLOADDATA_FAIL
} from "./action";
import { appConfig } from "../../config";

function* fetchTrips(value) {
  console.log(value);
  const token = localStorage.getItem("token");
  const loadID = value.payload.loadId;

  let user = JSON.parse(localStorage.getItem("user"));
  let userorgId = user.orgId;

  console.log(value);

  //For pagination purpose
  let pageno = !value.payload
    ? 1
    : value.payload.tpage === undefined
    ? 1
    : value.payload.tpage;

  try {
    const res = yield fetch(
      `${appConfig.ip}/trip?loadId=${loadID}&page=${pageno}&limit=10`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_TRIPS_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_TRIPS_FAIL, error: err });
    } else {
    }
  }
}

function* fetchTripDetailById(value) {
  const token = localStorage.getItem("token");
  let id = value.payload;

  try {
    const res = yield fetch(`${appConfig.ip}/trip/${id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_TRIPDETAILSBYID_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_TRIPDETAILSBYID_FAIL, error: err });
    } else {
    }
  }
}

function* fetchCompletedLoaddata(value) {
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));
  let userorgId = user.orgId;
  let dateFilter = (value.payload && value.payload.dateFilter) || "";

  //For pagination purpose
  let pageno = !value.payload
    ? 1
    : value.payload.page === undefined
    ? 1
    : value.payload.page === 0
    ? 1
    : value.payload.page;
  let status = !value.payload
    ? "created"
    : value.payload.status === undefined
    ? "created"
    : value.payload.status;

  let search = !value.payload
    ? ""
    : value.payload.search === undefined
    ? ""
    : value.payload.search;
  /* let status = !value.value
    ? ""
    : value.value.filter === ""
    ? ""
    : value.value.filter;
  let query = !value.value
    ? ""
    : value.value.queryToSearch === ""
    ? ""
    : value.value.queryToSearch; */

  try {
    const res =
      user.role === "runner"
        ? yield fetch(
            `${appConfig.ip}/loadData/shipper?page=${pageno}&limit=10&status=${status}&runnerOrgId=${userorgId}&ser=${search}${dateFilter}`,
            {
              method: "GET",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          )
        : yield fetch(
            `${appConfig.ip}/loadData/shipper?page=${pageno}&limit=10&status=${status}&orgId=${userorgId}&ser=${search}${dateFilter}`,
            {
              method: "GET",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_COMPLETEDLOADDATA_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_COMPLETEDLOADDATA_FAIL, error: err });
    } else {
    }
  }
}

export function* CompletedOrdersActionWatcher() {
  yield takeEvery(FETCH_TRIPS_INIT, fetchTrips);
  yield takeEvery(FETCH_TRIPDETAILSBYID_INIT, fetchTripDetailById);
  yield takeEvery(FETCH_COMPLETEDLOADDATA_INIT, fetchCompletedLoaddata);
}
